import { memo, ReactNode, useMemo } from 'react';

import { LinkButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';

export interface Props {
  configurationPageURL: string;
  branch: string;
  isBranchSet: boolean;
  tooltipActive: boolean;
  children?: ReactNode;
}

const SettingsButton = ({
  configurationPageURL,
  branch,
  isBranchSet,
  tooltipActive,
  children,
}: Props) => {
  const hasMainBranch = useMemo(() => {
    return isBranchSet && branch !== null;
  }, [isBranchSet, branch]);

  const tooltipContent = useMemo(() => {
    return tooltipActive && !hasMainBranch
      ? 'Commit some files in the repository before enabling Pipelines.'
      : '';
  }, [tooltipActive, hasMainBranch]);

  return (
    <Tooltip position="right" content={tooltipContent}>
      <LinkButton
        appearance="subtle"
        href={configurationPageURL}
        target="_parent"
        isDisabled={!hasMainBranch}
        testId="go-to-settings-link"
      >
        {children}
      </LinkButton>
    </Tooltip>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(SettingsButton);
